import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import * as Inputs from '../input'

import MapSet from '@components/input/model/map-extensor-model'

const Form = ({ children, onSubmit, onValidationChange, ...rest }) => {
  const allInputTypes = Object.values(Inputs)
  const [inputValidations, setInputValidations] = useState(new MapSet())
  const [hasProblemWithSomeInput, setHasProblemWithSomeInput] = useState(true)

  const appendInputValidation = ({ name, hasError }) => {
    setInputValidations(prevState => {
      return new MapSet([...prevState, [name, hasError]])
    })
  }

  const cloneChild = child => {
    if (!allInputTypes.includes(child?.type)) {
      if (child?.props?.children) {
        const innerChildren = cloneAllInnerChildren(child?.props?.children)
        return React.cloneElement(child, { children: innerChildren })
      }
      return child
    }

    const newChild = React.cloneElement(child, { onFieldValidation: appendInputValidation })
    return newChild
  }

  const cloneAllInnerChildren = children => {
    if (Array.isArray(children)) return React.Children.map(children, cloneChild)
    return cloneChild(children)
  }

  const clonedChildrens = React.Children.map(children, cloneChild)

  useEffect(() => {
    const inputErrosValues = Object.values(inputValidations.toObject())
    const hasError = inputErrosValues.some(Boolean)
    setHasProblemWithSomeInput(hasError)
  }, [inputValidations])

  useEffect(() => {
    if (onValidationChange) onValidationChange(hasProblemWithSomeInput)
  }, [hasProblemWithSomeInput, onValidationChange])

  const handlerOnSubmit = e => {
    e.preventDefault()
    if (onSubmit) onSubmit()
  }

  const formProps = {
    onSubmit: handlerOnSubmit,
    ...rest,
  }

  return <form {...formProps}>{clonedChildrens}</form>
}

Form.propTypes = {
  children: PropTypes.node,
  onSubmit: PropTypes.func,
  onValidationChange: PropTypes.func,
}

export default Form
